import request from '@/utils/request';

export function getGroupBuyActivity(id) {
  return request({
    url: '/Groupbuy/activity',
    params: {
      id,
    },
  });
}

export function getGroupBuyTeam(id) {
  return request({
    url: '/Groupbuy/team',
    params: {
      id,
    },
  });
}

export function getMyGroupBuy(params, silentRequest = false) {
  return request({
    url: '/My/groupbuys',
    params,
    silentRequest,
  });
}
